import { Injectable } from '@angular/core';
import { AppSettings } from './app-settings';
import { LoadingComponent } from '../components/loading/loading.component';
import { environment } from '../../../environments/environment';

/**
 * AppLoadService
 */
@Injectable()
export class AppLoadService {
    appSettingsPropertyNames = [
        'retailerPrivacyPolicyUrl',
        'retailerTermsAndConditions',
        'retailerBookingFormUrl',
        'retailerContactUsPageUrl',
        'retailerAddress',
        'retailerConfirmationAddress',
        'retailerName',
        'retailerEmailAddress',
        'retailerSalesTelephoneNumber',
        'retailerRttdThankyouPageUrl',
        'retailerId',
        'policyId',
        'policyVersion',
        'externalReferenceId',
        'nationalPrivacyPolicyUrl',
        'realtimeEndpointUrl',
        'contentRootUrl',
        'offSiteLocationCopy',
        'allowOffSite',
        'apiHostUrl',
        'satelliteRetailerCode',
        'sharedAssetsUrl',
        'eventJourney',
        'eventName',
        'eventConfirmationModelSelection',
        'eventAllowGuests',
        'eventModelTreeRef',
        'rescheduleId',
        'overridePdiImport',
        'overridePdiSource'
    ];

    /**
     * @description Attempts to find and return a query param from the URL.
     */
    private static getParameterByName(name: string): null | string | boolean {
        const url = new URL(window.location.href);
        const results = url.searchParams.get(name);

        if (!results) {
            return null;
        }
        if (results === 'true') {
            return true;
        }
        if (results === 'false') {
            return false;
        }

        return results;
    }

    /**
     * @ignore
     */
    constructor(
        private appSettings: AppSettings
    ) {
    }

    getSettings(): Promise<boolean> {

        return new Promise((resolve) => {
            const appTag: HTMLElement = document.querySelector('rttd-root');

            if (appTag) {
                // Set a value for each appSetting property. First from the values passed into
                // the app, then override if URL params are present.
                const spaConfig = JSON.parse(appTag.dataset.spaConfig);
                this.appSettingsPropertyNames.forEach(property => {
                    this.appSettings[property] = spaConfig[property];
                    // @todo Make this only available on local, dev and QA.
                    if (AppLoadService.getParameterByName(property) !== null) {
                        this.appSettings[property] = AppLoadService.getParameterByName(property);
                    }
                });

                this.appSettings.realtimeEndpointUrl = this.appSettings.apiHostUrl;
                this.appSettings.contentRootUrl = this.appSettings.contentRootUrl;
                this.appSettings.apiBrand = this.appSettings.externalReferenceId.includes("ireland") ? `${environment.brand}-ireland` : environment.brand
                resolve(true);
            } else {
                this.errorOut('External Reference ID Not Defined');
                resolve(false);
            }
        });
    }

    /**
     * @describe Set an existing property value.
     */
    set(name: string, value: any) {
        if (this.appSettings[name]) {
            this.appSettings[name] = value;
        }
    }

    errorOut(reason: string) {
        LoadingComponent.setErrorStatus(true, {statusText: reason});
    }

   }
